verticalAlign()

$(window).on('resize', function () {
    verticalAlign()
})

function verticalAlign() {
    $('.js_vertical-align').each((i, el) => {
        let items = $(el).attr('data-vertical')
        verticalAlignGrid($(el), items)
    })
}

function verticalAlignGrid(el, itemsNum = 4) {
    let num = el.find('.js_vertical-align__item').length
    if (window.innerWidth > 1023 && window.innerWidth <= 1535) {
        itemsNum = 4
    } else if (window.innerWidth > 767 && window.innerWidth <= 1023) {
        itemsNum = 3
    } else if (window.innerWidth > 567 && window.innerWidth <= 767) {
        itemsNum = 2
    } else if (window.innerWidth < 567) {
        itemsNum = 1
    }
    let rows = Math.ceil(num / itemsNum)
    let maxHeight = []
    el.find('.js_vertical-align__item').removeAttr('style')
    if (itemsNum > 1) {
        for (let r = 0; r < rows; r++) {
            el.find('.js_vertical-align__item').each((i, elem) => {
                if (i >= r * itemsNum && i <= (r + 1) * itemsNum - 1) {
                    if (maxHeight[r]) {
                        maxHeight[r] < $(elem).outerHeight() ? maxHeight[r] = $(elem).outerHeight() : ''
                    } else {
                        maxHeight[r] = $(elem).outerHeight()
                    }
                }
            })
        }
        for (let r = 0; r < rows; r++) {
            el.find('.js_vertical-align__item').each((i, elem) => {
                if (i >= r * itemsNum && i <= (r + 1) * itemsNum - 1) {
                    $(elem).height(maxHeight[r])
                }
            })
        }
    }
}